import CustomSwitchMUI from "./CustomSwitchMUI";
import { useDispatch, useSelector } from "react-redux";
const CompareSwitchComp = (props) => {
  const { responseid } = props;

  const show = true;
  return (
    <div>
      {show ? (
        <CustomSwitchMUI responseid={responseid}></CustomSwitchMUI>
      ) : null}
    </div>
  );
};

export default CompareSwitchComp;
